import React from "react";
import { Icon } from "antd";

export const confirmUpdate = {
  title: "Внимание!",
  content: "Вы действительно хотите сохранить внесенные изменения?",
  okText: "Сохранить",
  className: "modal-save-changes",
  cancelText: "Отмена",
  maskClosable: true,
  icon: <Icon style={{ color: "#9b9b9b" }} type="question-circle" />,
  closable: true,
  mask: true
};

export const confirmCreateOffer = {
  title: "Внимание",
  content: "Вы действительно хотите создать предложение?\n",
  okText: "Создать",
  cancelText: "Отмена",
  className: "confirm-red",
  okType: "primary",
  width: 432,
  cancelButtonProps: {
    type: "primary",
    ghost: true
  }
};

export const confirmCloseEditing = {
  title: "Внимание",
  content:
    "Вы действительно хотите отменить редактирование предложения? Несохраненные данные будут удалены!",
  okText: "Отменить изменения",
  cancelText: "Отмена",
  className: "modal-save-changes",
  okType: "danger",
  width: 432,
  cancelButtonProps: {
    type: "primary",
    ghost: true
  },
  okButtonProps: {
    ghost: true,
    type: "danger"
  },
  maskClosable: true,
  icon: <Icon style={{ color: "#f5222d" }} type="question-circle" />,
  closable: true,
  mask: true
};
